import { render, staticRenderFns } from "./ElepySingle.vue?vue&type=template&id=4d8d94ee&scoped=true&"
import script from "./ElepySingle.vue?vue&type=script&lang=js&"
export * from "./ElepySingle.vue?vue&type=script&lang=js&"
import style0 from "./ElepySingle.vue?vue&type=style&index=0&id=4d8d94ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d94ee",
  null
  
)

export default component.exports